import axios, { AxiosPromise, AxiosRequestHeaders } from "axios";
import { getToken, applyTrimAndRemoveEmpty, getTransientToken, getLocaleId, getRegKey } from "shared/utils";
import { getEnvironmentInfo } from "shared/utils/config";
import { HttpVerb } from "shared/utils/enums";
import { ApiClientInput, AxiosRequestConfig } from "./type";
import { errorToast } from "../utils/toastNotification";
import { getErrorMessage } from "../utils/network";

function client<T = any>(path: string, requestConfig?: ApiClientInput): AxiosPromise<T> {
  const {
    method,
    body,
    trimAndRemoveNull = true,
    baseUrl = getEnvironmentInfo().apiUrl,
    parseDataInResponse = true,
    noAuthHeader = false,
    params,
    customHeaders = {},
    ignoreLogoutOnAccessDenied,
    displayErrorMessage = true,
    responseType
  } = requestConfig || {};
  const lang = getLocaleId();
  const headers: AxiosRequestHeaders = { "content-type": "application/json", "x-source": "WEB", lang };
  const regKey = getRegKey();
  // since for console there won't be any reg key so added below check
  if (regKey && !path.includes("registration/findByRegistrationKeyOrId")) {
    headers["regKey"] = regKey;
  }

  // when calling open apis, send {noAuthHeader: true} so that auth header is not included
  if (!noAuthHeader) {
    const token = getToken();
    const transientToken = getTransientToken();
    if (token) {
      headers["x-auth-token"] = token;
    }
    if (transientToken) {
      headers["TRANSIENT-TOKEN"] = transientToken;
    }
  }

  const config: AxiosRequestConfig = {
    method: method ? method : body ? HttpVerb.POST : HttpVerb.GET,
    ignoreLogoutOnAccessDenied,
    headers: {
      ...headers,
      ...customHeaders
    }
  };
  return axios({
    url: `${baseUrl}/${path}`,
    params,
    data: body && trimAndRemoveNull ? applyTrimAndRemoveEmpty(body) : body,
    responseType,
    ...config
  })
    .then((response: any) => {
      return parseDataInResponse ? response?.data : response;
    })
    .catch(err => {
      displayErrorMessage && errorToast(getErrorMessage(err));
      throw err;
    });
}

export default client;
